import React from 'react'
import Link from '@cloudscape-design/components-themed/link'

// https://cloudscape.design/components/link
export function RadLink ({ ...rest }) {
  return (
    <Link {...rest} />
  )
}
